/* tslint:disable */
/* eslint-disable */
/**
 * Core Service API
 * This services provides an API to manage core svc calls.
 *
 * The version of the OpenAPI document: v1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface CoreSvcAdminhdlGetOutput
 */
export interface CoreSvcAdminhdlGetOutput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcAdminhdlGetOutput
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcAdminhdlGetOutput
   */
  services: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcAdminhdlGetOutput
   */
  status: string;
}
/**
 *
 * @export
 * @interface CoreSvcAuthActor
 */
export interface CoreSvcAuthActor {
  /**
   *
   * @type {string}
   * @memberof CoreSvcAuthActor
   */
  actingAsPrincipalId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcAuthActor
   */
  principalId?: string;
}
/**
 *
 * @export
 * @interface CoreSvcBulkActionResult
 */
export interface CoreSvcBulkActionResult {
  /**
   *
   * @type {string}
   * @memberof CoreSvcBulkActionResult
   */
  message?: string | null;
  /**
   *
   * @type {number}
   * @memberof CoreSvcBulkActionResult
   */
  status: number;
}
/**
 *
 * @export
 * @interface CoreSvcBulkUpdateOrgsInput
 */
export interface CoreSvcBulkUpdateOrgsInput {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof CoreSvcBulkUpdateOrgsInput
   */
  updates?: { [key: string]: string } | null;
}
/**
 *
 * @export
 * @interface CoreSvcBulkUpdateOutput
 */
export interface CoreSvcBulkUpdateOutput {
  /**
   *
   * @type {{ [key: string]: CoreSvcBulkActionResult; }}
   * @memberof CoreSvcBulkUpdateOutput
   */
  results?: { [key: string]: CoreSvcBulkActionResult } | null;
}
/**
 *
 * @export
 * @interface CoreSvcCreateOutput
 */
export interface CoreSvcCreateOutput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcCreateOutput
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcCreateOutput
   */
  workflowRunId: string;
}
/**
 *
 * @export
 * @interface CoreSvcCreatePaymentOrgOutput
 */
export interface CoreSvcCreatePaymentOrgOutput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcCreatePaymentOrgOutput
   */
  orgId: string;
}
/**
 *
 * @export
 * @interface CoreSvcDtosCreateOrgHierarchyEntityCreate
 */
export interface CoreSvcDtosCreateOrgHierarchyEntityCreate {
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosCreateOrgHierarchyEntityCreate
   */
  accountingConnectionId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosCreateOrgHierarchyEntityCreate
   */
  accountingConnectionSubsidiaryId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosCreateOrgHierarchyEntityCreate
   */
  clientId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosCreateOrgHierarchyEntityCreate
   */
  digitalAssetAccountCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosCreateOrgHierarchyEntityCreate
   */
  digitalAssetClearingAccountCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof CoreSvcDtosCreateOrgHierarchyEntityCreate
   */
  functionalCurrency?: number | null;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof CoreSvcDtosCreateOrgHierarchyEntityCreate
   */
  metadata?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosCreateOrgHierarchyEntityCreate
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosCreateOrgHierarchyEntityCreate
   */
  parentId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosCreateOrgHierarchyEntityCreate
   */
  type?: string;
}
/**
 *
 * @export
 * @interface CoreSvcDtosListOrgDTO
 */
export interface CoreSvcDtosListOrgDTO {
  /**
   *
   * @type {number}
   * @memberof CoreSvcDtosListOrgDTO
   */
  customerType?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcDtosListOrgDTO
   */
  deleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosListOrgDTO
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosListOrgDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosListOrgDTO
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosListOrgDTO
   */
  updatedBy?: string;
}
/**
 *
 * @export
 * @interface CoreSvcDtosTokenDTO
 */
export interface CoreSvcDtosTokenDTO {
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosTokenDTO
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosTokenDTO
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosTokenDTO
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosTokenDTO
   */
  principalId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosTokenDTO
   */
  serviceId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosTokenDTO
   */
  tokenDetails?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosTokenDTO
   */
  tokenId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosTokenDTO
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcDtosTokenDTO
   */
  updatedBy?: string;
}
/**
 *
 * @export
 * @interface CoreSvcGenerateScimTokenOutput
 */
export interface CoreSvcGenerateScimTokenOutput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcGenerateScimTokenOutput
   */
  token?: string;
}
/**
 *
 * @export
 * @interface CoreSvcGetOutput
 */
export interface CoreSvcGetOutput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcGetOutput
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcGetOutput
   */
  services: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcGetOutput
   */
  status: string;
}
/**
 *
 * @export
 * @interface CoreSvcGetShortListOutput
 */
export interface CoreSvcGetShortListOutput {
  /**
   *
   * @type {Array<CoreSvcDtosListOrgDTO>}
   * @memberof CoreSvcGetShortListOutput
   */
  items?: Array<CoreSvcDtosListOrgDTO> | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcGetShortListOutput
   */
  nextPageToken?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcHealthStatus
 */
export interface CoreSvcHealthStatus {
  /**
   *
   * @type {Array<object>}
   * @memberof CoreSvcHealthStatus
   */
  components?: Array<object> | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcHealthStatus
   */
  ready?: boolean;
  /**
   *
   * @type {string}
   * @memberof CoreSvcHealthStatus
   */
  timestamp?: string;
  /**
   *
   * @type {number}
   * @memberof CoreSvcHealthStatus
   */
  uptime?: number;
}
/**
 *
 * @export
 * @interface CoreSvcOrg
 */
export interface CoreSvcOrg {
  /**
   *
   * @type {CoreSvcOrgAccountingConfig}
   * @memberof CoreSvcOrg
   */
  accountingConfig?: CoreSvcOrgAccountingConfig;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  accountingInventoryGroupId?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrg
   */
  accountingInventoryGroupIds?: Array<string> | null;
  /**
   *
   * @type {CoreSvcOrgAccountingSetup}
   * @memberof CoreSvcOrg
   */
  accountingSetup?: CoreSvcOrgAccountingSetup;
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrg
   */
  baseCurrency?: number | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  billingOrgId?: string | null;
  /**
   *
   * @type {CoreSvcOrgClusterSettings}
   * @memberof CoreSvcOrg
   */
  cluster?: CoreSvcOrgClusterSettings;
  /**
   *
   * @type {CoreSvcOrgOrgConfig}
   * @memberof CoreSvcOrg
   */
  config?: CoreSvcOrgOrgConfig;
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrg
   */
  created?: number;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  createdByPrincipalId?: string;
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrg
   */
  customerType?: number | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  defaultFeeCategoryId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  defiGroupWalletId?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrg
   */
  deleted?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrg
   */
  disabled?: boolean | null;
  /**
   *
   * @type {CoreSvcOrgDisplayConfig}
   * @memberof CoreSvcOrg
   */
  displayConfig?: CoreSvcOrgDisplayConfig;
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrg
   */
  engineVersion?: number | null;
  /**
   *
   * @type {CoreSvcOrgEnterprisePaymentSettings}
   * @memberof CoreSvcOrg
   */
  enterprisePaymentSettings?: CoreSvcOrgEnterprisePaymentSettings;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof CoreSvcOrg
   */
  flags?: { [key: string]: string } | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  hardCloseDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  id?: string | null;
  /**
   *
   * @type {CoreSvcOrgInvoicingSettings}
   * @memberof CoreSvcOrg
   */
  invoicingSettings?: CoreSvcOrgInvoicingSettings;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  kekResourceName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  logoFileName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  name?: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof CoreSvcOrg
   */
  networkContactIds?: { [key: string]: string } | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  parentOrgId?: string | null;
  /**
   *
   * @type {CoreSvcOrgOrgPersistenceSettings}
   * @memberof CoreSvcOrg
   */
  persistenceSettings?: CoreSvcOrgOrgPersistenceSettings;
  /**
   *
   * @type {CoreSvcOrgPricingSettings}
   * @memberof CoreSvcOrg
   */
  pricingSettings?: CoreSvcOrgPricingSettings;
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrg
   */
  provisionedAccountingUsers?: number | null;
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrg
   */
  provisionedUsers?: number | null;
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrg
   */
  provisionedWalletUsers?: number | null;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof CoreSvcOrg
   */
  roles?: { [key: string]: number } | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  scimTokenHash?: string | null;
  /**
   *
   * @type {CoreSvcOrgSsoSettings}
   * @memberof CoreSvcOrg
   */
  sso?: CoreSvcOrgSsoSettings;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  storageBucket?: string | null;
  /**
   *
   * @type {CoreSvcOrgSubscriptionDetails}
   * @memberof CoreSvcOrg
   */
  subscriptionDetails?: CoreSvcOrgSubscriptionDetails;
  /**
   *
   * @type {CoreSvcOrgGainLossConfig}
   * @memberof CoreSvcOrg
   */
  taxConfig?: CoreSvcOrgGainLossConfig;
  /**
   *
   * @type {object}
   * @memberof CoreSvcOrg
   */
  taxStrategy?: object;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrg
   */
  testOrg?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  timezone?: string | null;
  /**
   *
   * @type {CoreSvcOrgTokenFilteringRulesConfig}
   * @memberof CoreSvcOrg
   */
  tokenFilteringConfig?: CoreSvcOrgTokenFilteringRulesConfig;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  trialExpiry?: string | null;
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrg
   */
  updated?: number;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrg
   */
  updatedByPrincipalId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrg
   */
  walletIds?: Array<string>;
}
/**
 *
 * @export
 * @interface CoreSvcOrgAccountingConfig
 */
export interface CoreSvcOrgAccountingConfig {
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgAccountingConfig
   */
  allowTxnInference?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgAccountingConfig
   */
  collapseAcrossWallets?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgAccountingConfig
   */
  defaultAccountsPayableCategoryId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgAccountingConfig
   */
  defaultAccountsReceivableCategoryId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgAccountingConfig
   */
  defaultFeeCategoryId?: string | null;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof CoreSvcOrgAccountingConfig
   */
  defaultFeeCategoryIds?: { [key: string]: string };
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgAccountingConfig
   */
  multiCurrency?: boolean | null;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof CoreSvcOrgAccountingConfig
   */
  networkContactIds?: { [key: string]: string };
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgAccountingConfig
   */
  separateFeeTransactions?: boolean | null;
}
/**
 *
 * @export
 * @interface CoreSvcOrgAccountingSetup
 */
export interface CoreSvcOrgAccountingSetup {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgAccountingSetup
   */
  balanceExportReportId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgAccountingSetup
   */
  balanceExportStartDate?: string | null;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof CoreSvcOrgAccountingSetup
   */
  flags?: { [key: string]: string };
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrgAccountingSetup
   */
  initialSyncMethod?: number;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgAccountingSetup
   */
  isFinished?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgAccountingSetup
   */
  isReconciled?: boolean | null;
}
/**
 *
 * @export
 * @interface CoreSvcOrgAllowDeployedBlockHeightRule
 */
export interface CoreSvcOrgAllowDeployedBlockHeightRule {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgAllowDeployedBlockHeightRule
   */
  blockNumber?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgAllowDeployedBlockHeightRule
   */
  evaluator?: string;
}
/**
 *
 * @export
 * @interface CoreSvcOrgAssetValuationStrategy
 */
export interface CoreSvcOrgAssetValuationStrategy {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgAssetValuationStrategy
   */
  assetValuationStrategy?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgAssetValuationStrategy
   */
  currencyId?: string;
}
/**
 *
 * @export
 * @interface CoreSvcOrgClusterSettings
 */
export interface CoreSvcOrgClusterSettings {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgClusterSettings
   */
  primary?: string;
  /**
   *
   * @type {{ [key: string]: object; }}
   * @memberof CoreSvcOrgClusterSettings
   */
  replicas?: { [key: string]: object };
}
/**
 *
 * @export
 * @interface CoreSvcOrgCreateOrgDTO
 */
export interface CoreSvcOrgCreateOrgDTO {
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrgCreateOrgDTO
   */
  baseCurrency: number;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreateOrgDTO
   */
  clientId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreateOrgDTO
   */
  db?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreateOrgDTO
   */
  kekResourceName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreateOrgDTO
   */
  name: string;
  /**
   *
   * @type {CoreSvcOrgOrgCreateOptions}
   * @memberof CoreSvcOrgCreateOrgDTO
   */
  options?: CoreSvcOrgOrgCreateOptions;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreateOrgDTO
   */
  orgType: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreateOrgDTO
   */
  primaryCluster: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrgCreateOrgDTO
   */
  replicationClusters?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreateOrgDTO
   */
  timeZone: string;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgCreateOrgDTO
   */
  usePriceService?: boolean;
}
/**
 *
 * @export
 * @interface CoreSvcOrgCreatePaymentOrgDTO
 */
export interface CoreSvcOrgCreatePaymentOrgDTO {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  apEmailAddress?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  arEmailAddress?: string;
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  baseCurrency: number;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  billingContactEmail?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  billingContactName?: string;
  /**
   *
   * @type {CoreSvcOrgCreatePaymentOrgDTOBusinessAddress}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  businessAddress?: CoreSvcOrgCreatePaymentOrgDTOBusinessAddress;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  businessDescription?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  businessEmail?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  businessName: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  businessPhoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  businessWebsiteUrl?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  clientId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  db?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  kekResourceName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  name: string;
  /**
   *
   * @type {CoreSvcOrgOrgCreateOptions}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  options?: CoreSvcOrgOrgCreateOptions;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  orgType: string;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  paymentNetworkOptin?: boolean;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  primaryCluster: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  productType?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  replicationClusters?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  timeZone: string;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgCreatePaymentOrgDTO
   */
  usePriceService?: boolean;
}
/**
 *
 * @export
 * @interface CoreSvcOrgCreatePaymentOrgDTOBusinessAddress
 */
export interface CoreSvcOrgCreatePaymentOrgDTOBusinessAddress {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTOBusinessAddress
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTOBusinessAddress
   */
  state?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTOBusinessAddress
   */
  street?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgCreatePaymentOrgDTOBusinessAddress
   */
  zipcode?: string;
}
/**
 *
 * @export
 * @interface CoreSvcOrgDisabledDeployedByBlockHeightRule
 */
export interface CoreSvcOrgDisabledDeployedByBlockHeightRule {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgDisabledDeployedByBlockHeightRule
   */
  blockNumber?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgDisabledDeployedByBlockHeightRule
   */
  evaluator?: string;
}
/**
 *
 * @export
 * @interface CoreSvcOrgDisplayConfig
 */
export interface CoreSvcOrgDisplayConfig {
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgDisplayConfig
   */
  useOrgTimezone?: boolean;
}
/**
 *
 * @export
 * @interface CoreSvcOrgEnterprisePaymentSettings
 */
export interface CoreSvcOrgEnterprisePaymentSettings {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  custodian?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  defaultFeeCategoryId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  defaultFeeContactId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  defaultForexCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  defaultPricingMethod?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  enabledCryptoCurrencies?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  enabledFiats?: Array<string> | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  isKytDisabled?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  kycProvider?: string;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  locked?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  pricingSources?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  pricingTimezone?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  remittanceContactEmail?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgEnterprisePaymentSettings
   */
  remittanceSenderName?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcOrgGainLossConfig
 */
export interface CoreSvcOrgGainLossConfig {
  /**
   *
   * @type {Array<CoreSvcOrgAssetValuationStrategy>}
   * @memberof CoreSvcOrgGainLossConfig
   */
  assetValuationStrategies?: Array<CoreSvcOrgAssetValuationStrategy>;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgGainLossConfig
   */
  capitalizeTradingFees?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgGainLossConfig
   */
  costBasisCarryForwardAcquiredSide?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgGainLossConfig
   */
  defaultValuationStrategy?: string | null;
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrgGainLossConfig
   */
  engineVersion?: number | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgGainLossConfig
   */
  impairmentMethodology?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrgGainLossConfig
   */
  impairmentWhitelist?: Array<string>;
  /**
   *
   * @type {CoreSvcOrgInventoryMappingRule}
   * @memberof CoreSvcOrgGainLossConfig
   */
  inventoryMappingRule?: CoreSvcOrgInventoryMappingRule;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgGainLossConfig
   */
  processAcquisitionsBeforeDisposals?: boolean | null;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof CoreSvcOrgGainLossConfig
   */
  wrappingTreatments?: { [key: string]: Array<string> } | null;
}
/**
 *
 * @export
 * @interface CoreSvcOrgInventoryMappingRule
 */
export interface CoreSvcOrgInventoryMappingRule {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgInventoryMappingRule
   */
  inventoryGroupId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgInventoryMappingRule
   */
  type?: string;
}
/**
 *
 * @export
 * @interface CoreSvcOrgInvoicingSettings
 */
export interface CoreSvcOrgInvoicingSettings {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgInvoicingSettings
   */
  bitcoinAddress?: string | null;
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrgInvoicingSettings
   */
  bitcoinCurrentXPubIndex?: number | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgInvoicingSettings
   */
  bitcoinXPub?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgInvoicingSettings
   */
  bitcoinXPubPath?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgInvoicingSettings
   */
  ethAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgInvoicingSettings
   */
  fromEmail?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgInvoicingSettings
   */
  fromName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgInvoicingSettings
   */
  usdcAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgInvoicingSettings
   */
  usdtAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgInvoicingSettings
   */
  zecAddress?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcOrgOrgAdminConfig
 */
export interface CoreSvcOrgOrgAdminConfig {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgOrgAdminConfig
   */
  releaseChannel?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcOrgOrgConfig
 */
export interface CoreSvcOrgOrgConfig {
  /**
   *
   * @type {CoreSvcOrgOrgAdminConfig}
   * @memberof CoreSvcOrgOrgConfig
   */
  adminConfig?: CoreSvcOrgOrgAdminConfig;
  /**
   *
   * @type {CoreSvcOrgOrgStaticConfig}
   * @memberof CoreSvcOrgOrgConfig
   */
  staticConfig?: CoreSvcOrgOrgStaticConfig;
  /**
   *
   * @type {CoreSvcOrgOrgSystemConfig}
   * @memberof CoreSvcOrgOrgConfig
   */
  systemConfig?: CoreSvcOrgOrgSystemConfig;
}
/**
 *
 * @export
 * @interface CoreSvcOrgOrgCreateOptions
 */
export interface CoreSvcOrgOrgCreateOptions {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof CoreSvcOrgOrgCreateOptions
   */
  featureFlags?: { [key: string]: string };
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgOrgCreateOptions
   */
  useNewRulesUI?: boolean | null;
}
/**
 *
 * @export
 * @interface CoreSvcOrgOrgPersistenceSettings
 */
export interface CoreSvcOrgOrgPersistenceSettings {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgOrgPersistenceSettings
   */
  databaseInstance?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgOrgPersistenceSettings
   */
  databaseName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgOrgPersistenceSettings
   */
  databaseProject?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgOrgPersistenceSettings
   */
  provider?: string;
}
/**
 *
 * @export
 * @interface CoreSvcOrgOrgStaticConfig
 */
export interface CoreSvcOrgOrgStaticConfig {
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgOrgStaticConfig
   */
  eventSourced?: boolean;
}
/**
 *
 * @export
 * @interface CoreSvcOrgOrgSystemConfig
 */
export interface CoreSvcOrgOrgSystemConfig {
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgOrgSystemConfig
   */
  showReleaseChannels?: boolean;
}
/**
 *
 * @export
 * @interface CoreSvcOrgPricingSettings
 */
export interface CoreSvcOrgPricingSettings {
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrgPricingSettings
   */
  preferredExchange?: number | null;
}
/**
 *
 * @export
 * @interface CoreSvcOrgSsoSettings
 */
export interface CoreSvcOrgSsoSettings {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgSsoSettings
   */
  defaultRoleId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgSsoSettings
   */
  idpCertificate?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgSsoSettings
   */
  idpIssuer?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgSsoSettings
   */
  idpSignOnUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgSsoSettings
   */
  requireSso?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgSsoSettings
   */
  use?: boolean | null;
}
/**
 *
 * @export
 * @interface CoreSvcOrgSubscriptionDetails
 */
export interface CoreSvcOrgSubscriptionDetails {
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrgSubscriptionDetails
   */
  accountingLicenses?: number;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgSubscriptionDetails
   */
  customerId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgSubscriptionDetails
   */
  subscriptionId?: string | null;
  /**
   *
   * @type {number}
   * @memberof CoreSvcOrgSubscriptionDetails
   */
  walletLicenses?: number;
}
/**
 *
 * @export
 * @interface CoreSvcOrgTokenFilteringRulesConfig
 */
export interface CoreSvcOrgTokenFilteringRulesConfig {
  /**
   *
   * @type {Array<CoreSvcOrgAllowDeployedBlockHeightRule>}
   * @memberof CoreSvcOrgTokenFilteringRulesConfig
   */
  allowDeployedBlockHeightRules?: Array<CoreSvcOrgAllowDeployedBlockHeightRule>;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrgTokenFilteringRulesConfig
   */
  allowedContractAddresses?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrgTokenFilteringRulesConfig
   */
  allowedDeployedByAddresses?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrgTokenFilteringRulesConfig
   */
  disabledContractAddresses?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrgTokenFilteringRulesConfig
   */
  disabledDeployedByAddresses?: Array<string>;
  /**
   *
   * @type {Array<CoreSvcOrgDisabledDeployedByBlockHeightRule>}
   * @memberof CoreSvcOrgTokenFilteringRulesConfig
   */
  disabledDeployedByBlockHeightRules?: Array<CoreSvcOrgDisabledDeployedByBlockHeightRule>;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgTokenFilteringRulesConfig
   */
  erc20FilterThreshold?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcOrgTokenFilteringRulesConfig
   */
  filteredAddresses?: Array<string>;
  /**
   *
   * @type {Array<CoreSvcOrgWalletSyncPreference>}
   * @memberof CoreSvcOrgTokenFilteringRulesConfig
   */
  walletSyncPreferences?: Array<CoreSvcOrgWalletSyncPreference>;
}
/**
 *
 * @export
 * @interface CoreSvcOrgWalletSyncPreference
 */
export interface CoreSvcOrgWalletSyncPreference {
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgWalletSyncPreference
   */
  syncAllLogEvents?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgWalletSyncPreference
   */
  walletId?: string;
}
/**
 *
 * @export
 * @interface CoreSvcOrgprincipalsIdentityDTO
 */
export interface CoreSvcOrgprincipalsIdentityDTO {
  /**
   *
   * @type {any}
   * @memberof CoreSvcOrgprincipalsIdentityDTO
   */
  data?: any;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcOrgprincipalsIdentityDTO
   */
  enabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsIdentityDTO
   */
  identityId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsIdentityDTO
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsIdentityDTO
   */
  remoteId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsIdentityDTO
   */
  remoteSystem?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsIdentityDTO
   */
  type?: string;
}
/**
 *
 * @export
 * @interface CoreSvcOrgprincipalsOrgPrincipalDTO
 */
export interface CoreSvcOrgprincipalsOrgPrincipalDTO {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalDTO
   */
  assertedIdentity?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalDTO
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalDTO
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalDTO
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalDTO
   */
  principalId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalDTO
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalDTO
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalDTO
   */
  updatedBy?: string;
}
/**
 *
 * @export
 * @interface CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
 */
export interface CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  assertedIdentity?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  expiresAt?: string | null;
  /**
   *
   * @type {Array<CoreSvcOrgprincipalsIdentityDTO>}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  identities?: Array<CoreSvcOrgprincipalsIdentityDTO>;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  principalEmail?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  principalId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  principalName?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  principalType?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  roleId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  roleName?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO
   */
  updatedBy?: string;
}
/**
 *
 * @export
 * @interface CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
 */
export interface CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  assertedIdentity?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  createdBy?: string;
  /**
   *
   * @type {Array<CoreSvcOrgprincipalsIdentityDTO>}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  identities?: Array<CoreSvcOrgprincipalsIdentityDTO>;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  principalEmail?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  principalId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  principalName?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  principalType?: string;
  /**
   *
   * @type {Array<CoreSvcOrgprincipalsRoleDTO>}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  roles?: Array<CoreSvcOrgprincipalsRoleDTO> | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO
   */
  updatedBy?: string;
}
/**
 *
 * @export
 * @interface CoreSvcOrgprincipalsRoleDTO
 */
export interface CoreSvcOrgprincipalsRoleDTO {
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsRoleDTO
   */
  expiresAt?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsRoleDTO
   */
  roleId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcOrgprincipalsRoleDTO
   */
  roleName?: string;
}
/**
 *
 * @export
 * @interface CoreSvcPrincipalshdlCreateInput
 */
export interface CoreSvcPrincipalshdlCreateInput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcPrincipalshdlCreateInput
   */
  assertedIdentity?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcPrincipalshdlCreateInput
   */
  roleId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcPrincipalshdlCreateInput
   */
  subsidiaryId?: string;
}
/**
 *
 * @export
 * @interface CoreSvcPrincipalshdlCreateOutput
 */
export interface CoreSvcPrincipalshdlCreateOutput {
  /**
   *
   * @type {CoreSvcOrgprincipalsOrgPrincipalDTO}
   * @memberof CoreSvcPrincipalshdlCreateOutput
   */
  orgPrincipal?: CoreSvcOrgprincipalsOrgPrincipalDTO;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcPrincipalshdlCreateOutput
   */
  roleIds?: Array<string> | null;
}
/**
 *
 * @export
 * @interface CoreSvcPrincipalshdlGetOutput
 */
export interface CoreSvcPrincipalshdlGetOutput {
  /**
   *
   * @type {CoreSvcOrgprincipalsOrgPrincipalDTO}
   * @memberof CoreSvcPrincipalshdlGetOutput
   */
  orgPrincipal?: CoreSvcOrgprincipalsOrgPrincipalDTO;
}
/**
 *
 * @export
 * @interface CoreSvcPrincipalshdlListAggregatedOutput
 */
export interface CoreSvcPrincipalshdlListAggregatedOutput {
  /**
   *
   * @type {Array<CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO>}
   * @memberof CoreSvcPrincipalshdlListAggregatedOutput
   */
  items?: Array<CoreSvcOrgprincipalsOrgPrincipalWithRolesDTO> | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcPrincipalshdlListAggregatedOutput
   */
  nextPageToken?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcPrincipalshdlListOutput
 */
export interface CoreSvcPrincipalshdlListOutput {
  /**
   *
   * @type {Array<CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO>}
   * @memberof CoreSvcPrincipalshdlListOutput
   */
  items?: Array<CoreSvcOrgprincipalsOrgPrincipalWithRoleDTO> | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcPrincipalshdlListOutput
   */
  nextPageToken?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcPrincipalshdlUpdateInput
 */
export interface CoreSvcPrincipalshdlUpdateInput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcPrincipalshdlUpdateInput
   */
  assertedIdentity?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcPrincipalshdlUpdateInput
   */
  subsidiaryId?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcPrincipalshdlUpdateOutput
 */
export interface CoreSvcPrincipalshdlUpdateOutput {
  /**
   *
   * @type {CoreSvcOrgprincipalsOrgPrincipalDTO}
   * @memberof CoreSvcPrincipalshdlUpdateOutput
   */
  orgPrincipal?: CoreSvcOrgprincipalsOrgPrincipalDTO;
}
/**
 *
 * @export
 * @interface CoreSvcRolesRole
 */
export interface CoreSvcRolesRole {
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcRolesRole
   */
  IsOrgDefaultRole?: boolean;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRole
   */
  createdAt?: string;
  /**
   *
   * @type {CoreSvcAuthActor}
   * @memberof CoreSvcRolesRole
   */
  createdByActor?: CoreSvcAuthActor;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRole
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcRolesRole
   */
  isArchived?: boolean;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRole
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRole
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRole
   */
  roleDefinitionId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRole
   */
  roleId?: string;
  /**
   *
   * @type {{ [key: string]: object; }}
   * @memberof CoreSvcRolesRole
   */
  scopes?: { [key: string]: object };
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRole
   */
  updatedAt?: string;
  /**
   *
   * @type {CoreSvcAuthActor}
   * @memberof CoreSvcRolesRole
   */
  updatedByActor?: CoreSvcAuthActor;
}
/**
 *
 * @export
 * @interface CoreSvcRolesRoleCreateInput
 */
export interface CoreSvcRolesRoleCreateInput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRoleCreateInput
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRoleCreateInput
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRoleCreateInput
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRoleCreateInput
   */
  roleDefinitionId?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcRolesRoleCreateInput
   */
  scopes?: Array<string>;
}
/**
 *
 * @export
 * @interface CoreSvcRolesRoleUpdateInput
 */
export interface CoreSvcRolesRoleUpdateInput {
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcRolesRoleUpdateInput
   */
  archived?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRoleUpdateInput
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRoleUpdateInput
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRoleUpdateInput
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRolesRoleUpdateInput
   */
  roleId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcRolesRoleUpdateInput
   */
  scopes?: Array<string>;
}
/**
 *
 * @export
 * @interface CoreSvcRoleshdlCreateRolesOutput
 */
export interface CoreSvcRoleshdlCreateRolesOutput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcRoleshdlCreateRolesOutput
   */
  roleId?: string;
}
/**
 *
 * @export
 * @interface CoreSvcRoleshdlGetOrgRolesOutput
 */
export interface CoreSvcRoleshdlGetOrgRolesOutput {
  /**
   *
   * @type {Array<CoreSvcRolesRole>}
   * @memberof CoreSvcRoleshdlGetOrgRolesOutput
   */
  items?: Array<CoreSvcRolesRole> | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcRoleshdlGetOrgRolesOutput
   */
  nextPageToken?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcRoleshdlGetRoleOutput
 */
export interface CoreSvcRoleshdlGetRoleOutput {
  /**
   *
   * @type {CoreSvcRolesRole}
   * @memberof CoreSvcRoleshdlGetRoleOutput
   */
  role?: CoreSvcRolesRole;
}
/**
 *
 * @export
 * @interface CoreSvcScopeshdlGetScopesOutput
 */
export interface CoreSvcScopeshdlGetScopesOutput {
  /**
   *
   * @type {Array<CoreSvcScopeshdlScopeDTO>}
   * @memberof CoreSvcScopeshdlGetScopesOutput
   */
  scopes?: Array<CoreSvcScopeshdlScopeDTO> | null;
}
/**
 *
 * @export
 * @interface CoreSvcScopeshdlScopeDTO
 */
export interface CoreSvcScopeshdlScopeDTO {
  /**
   *
   * @type {string}
   * @memberof CoreSvcScopeshdlScopeDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcScopeshdlScopeDTO
   */
  friendlyEntity?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcScopeshdlScopeDTO
   */
  friendlySubEntity?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcScopeshdlScopeDTO
   */
  groups?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CoreSvcScopeshdlScopeDTO
   */
  permissionType?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcScopeshdlScopeDTO
   */
  requiredOrgFlags?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CoreSvcScopeshdlScopeDTO
   */
  scope?: string;
}
/**
 *
 * @export
 * @interface CoreSvcStructurehdlGetListOutput
 */
export interface CoreSvcStructurehdlGetListOutput {
  /**
   *
   * @type {Array<CoreSvcStructurehdlOrgStructureEntity>}
   * @memberof CoreSvcStructurehdlGetListOutput
   */
  items?: Array<CoreSvcStructurehdlOrgStructureEntity> | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlGetListOutput
   */
  nextPageToken?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcStructurehdlGetUpdateOutput
 */
export interface CoreSvcStructurehdlGetUpdateOutput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlGetUpdateOutput
   */
  id?: string;
}
/**
 *
 * @export
 * @interface CoreSvcStructurehdlOrgStructureEntity
 */
export interface CoreSvcStructurehdlOrgStructureEntity {
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlOrgStructureEntity
   */
  accountingConnectionId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlOrgStructureEntity
   */
  accountingConnectionSubsidiaryId?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcStructurehdlOrgStructureEntity
   */
  deleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlOrgStructureEntity
   */
  digitalAssetAccountCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlOrgStructureEntity
   */
  digitalAssetClearingAccountCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof CoreSvcStructurehdlOrgStructureEntity
   */
  functionalCurrency?: number | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlOrgStructureEntity
   */
  id?: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof CoreSvcStructurehdlOrgStructureEntity
   */
  metadata?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlOrgStructureEntity
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlOrgStructureEntity
   */
  parentId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlOrgStructureEntity
   */
  type?: string;
}
/**
 *
 * @export
 * @interface CoreSvcStructurehdlUpdateInput
 */
export interface CoreSvcStructurehdlUpdateInput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlUpdateInput
   */
  accountingConnectionId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlUpdateInput
   */
  accountingConnectionSubsidiaryId?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcStructurehdlUpdateInput
   */
  deleted?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlUpdateInput
   */
  digitalAssetAccountCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlUpdateInput
   */
  digitalAssetClearingAccountCode?: string | null;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof CoreSvcStructurehdlUpdateInput
   */
  metadata?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof CoreSvcStructurehdlUpdateInput
   */
  name?: string;
}
/**
 *
 * @export
 * @interface CoreSvcTokenshdlCreateTokenInput
 */
export interface CoreSvcTokenshdlCreateTokenInput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlCreateTokenInput
   */
  serviceId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlCreateTokenInput
   */
  tokenDetails?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlCreateTokenInput
   */
  tokenId?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcTokenshdlCreateTokenOutput
 */
export interface CoreSvcTokenshdlCreateTokenOutput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlCreateTokenOutput
   */
  tokenId: string;
}
/**
 *
 * @export
 * @interface CoreSvcTokenshdlTokenOutput
 */
export interface CoreSvcTokenshdlTokenOutput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlTokenOutput
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlTokenOutput
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlTokenOutput
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlTokenOutput
   */
  principalId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlTokenOutput
   */
  serviceId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlTokenOutput
   */
  tokenDetails?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlTokenOutput
   */
  tokenId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlTokenOutput
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlTokenOutput
   */
  updatedBy?: string;
}
/**
 *
 * @export
 * @interface CoreSvcTokenshdlTokensOutput
 */
export interface CoreSvcTokenshdlTokensOutput {
  /**
   *
   * @type {Array<CoreSvcDtosTokenDTO>}
   * @memberof CoreSvcTokenshdlTokensOutput
   */
  items?: Array<CoreSvcDtosTokenDTO> | null;
}
/**
 *
 * @export
 * @interface CoreSvcTokenshdlUpdateTokenInput
 */
export interface CoreSvcTokenshdlUpdateTokenInput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlUpdateTokenInput
   */
  principalId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlUpdateTokenInput
   */
  serviceId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcTokenshdlUpdateTokenInput
   */
  tokenDetails?: string;
}
/**
 *
 * @export
 * @interface CoreSvcUpdateOrgAccountingInventorySettingsInput
 */
export interface CoreSvcUpdateOrgAccountingInventorySettingsInput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgAccountingInventorySettingsInput
   */
  accountingInventoryGroupId?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcUpdateOrgAccountingInventorySettingsInput
   */
  accountingInventoryGroupIds?: Array<string> | null;
}
/**
 *
 * @export
 * @interface CoreSvcUpdateOrgAdminSettingsInput
 */
export interface CoreSvcUpdateOrgAdminSettingsInput {
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcUpdateOrgAdminSettingsInput
   */
  capitalizeTradingFees?: boolean | null;
  /**
   *
   * @type {CoreSvcOrgDisplayConfig}
   * @memberof CoreSvcUpdateOrgAdminSettingsInput
   */
  displayConfig?: CoreSvcOrgDisplayConfig;
  /**
   *
   * @type {number}
   * @memberof CoreSvcUpdateOrgAdminSettingsInput
   */
  engineVersion?: number | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgAdminSettingsInput
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgAdminSettingsInput
   */
  releaseChannel?: string | null;
  /**
   *
   * @type {CoreSvcOrgGainLossConfig}
   * @memberof CoreSvcUpdateOrgAdminSettingsInput
   */
  taxConfig?: CoreSvcOrgGainLossConfig;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcUpdateOrgAdminSettingsInput
   */
  useOrgTimezoneForDisplay?: boolean | null;
}
/**
 *
 * @export
 * @interface CoreSvcUpdateOrgEnterprisePaymentSettingsInput
 */
export interface CoreSvcUpdateOrgEnterprisePaymentSettingsInput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  custodian?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  defaultFeeCategoryId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  defaultFeeContactId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  defaultForexCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  defaultPricingMethod?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  enabledCryptoCurrencies?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  enabledFiats?: Array<string> | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  isKytDisabled?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  kycProvider?: string;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  locked?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  pricingSources?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  pricingTimezone?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  remittanceContactEmail?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgEnterprisePaymentSettingsInput
   */
  remittanceSenderName?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcUpdateOrgFeatureFlagsInput
 */
export interface CoreSvcUpdateOrgFeatureFlagsInput {
  /**
   *
   * @type {Array<string>}
   * @memberof CoreSvcUpdateOrgFeatureFlagsInput
   */
  featureFlags?: Array<string> | null;
}
/**
 *
 * @export
 * @interface CoreSvcUpdateOrgHardCloseInput
 */
export interface CoreSvcUpdateOrgHardCloseInput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgHardCloseInput
   */
  hardCloseDate?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcUpdateOrgSsoSettingsInput
 */
export interface CoreSvcUpdateOrgSsoSettingsInput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgSsoSettingsInput
   */
  defaultRoleId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgSsoSettingsInput
   */
  idpCertificate?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgSsoSettingsInput
   */
  idpIssuer?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgSsoSettingsInput
   */
  idpSignOnUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcUpdateOrgSsoSettingsInput
   */
  requireSso?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcUpdateOrgSsoSettingsInput
   */
  use?: boolean | null;
}
/**
 *
 * @export
 * @interface CoreSvcUpdateOrgSystemSettingsInput
 */
export interface CoreSvcUpdateOrgSystemSettingsInput {
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgSystemSettingsInput
   */
  KEKResourceName?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CoreSvcUpdateOrgSystemSettingsInput
   */
  allowReleaseChannels?: boolean | null;
  /**
   *
   * @type {number}
   * @memberof CoreSvcUpdateOrgSystemSettingsInput
   */
  customerType?: number;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgSystemSettingsInput
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgSystemSettingsInput
   */
  storageBucket?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgSystemSettingsInput
   */
  timezone?: string | null;
  /**
   *
   * @type {string}
   * @memberof CoreSvcUpdateOrgSystemSettingsInput
   */
  trialExpiry?: string | null;
}
/**
 *
 * @export
 * @interface CoreSvcUpdateOrgWrappingTreatmentsInput
 */
export interface CoreSvcUpdateOrgWrappingTreatmentsInput {
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof CoreSvcUpdateOrgWrappingTreatmentsInput
   */
  wrappingTreatments?: { [key: string]: Array<string> } | null;
}
/**
 *
 * @export
 * @interface CoreSvcUtilsHealthHandlerRegisterRoutes200Response
 */
export interface CoreSvcUtilsHealthHandlerRegisterRoutes200Response {
  /**
   *
   * @type {string}
   * @memberof CoreSvcUtilsHealthHandlerRegisterRoutes200Response
   */
  status?: string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary admin HTTP Handler Run Org Event Migration 1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    httpAdminhdlAdminHTTPHandlerRunOrgEventMigration1: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/admin/migrations/org-event-migration-1`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Create
     * @param {string} [authorization]
     * @param {CoreSvcOrgCreateOrgDTO} [coreSvcOrgCreateOrgDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    httpOrgshdlOrgsHTTPHandlerCreate: async (
      authorization?: string,
      coreSvcOrgCreateOrgDTO?: CoreSvcOrgCreateOrgDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/orgs/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcOrgCreateOrgDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary admin HTTP Handler Run Org Event Migration 1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async httpAdminhdlAdminHTTPHandlerRunOrgEventMigration1(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcAdminhdlGetOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.httpAdminhdlAdminHTTPHandlerRunOrgEventMigration1(
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Create
     * @param {string} [authorization]
     * @param {CoreSvcOrgCreateOrgDTO} [coreSvcOrgCreateOrgDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async httpOrgshdlOrgsHTTPHandlerCreate(
      authorization?: string,
      coreSvcOrgCreateOrgDTO?: CoreSvcOrgCreateOrgDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcCreateOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.httpOrgshdlOrgsHTTPHandlerCreate(
        authorization,
        coreSvcOrgCreateOrgDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = DefaultApiFp(configuration);
  return {
    /**
     *
     * @summary admin HTTP Handler Run Org Event Migration 1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    httpAdminhdlAdminHTTPHandlerRunOrgEventMigration1(options?: any): AxiosPromise<CoreSvcAdminhdlGetOutput> {
      return localVarFp
        .httpAdminhdlAdminHTTPHandlerRunOrgEventMigration1(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Create
     * @param {string} [authorization]
     * @param {CoreSvcOrgCreateOrgDTO} [coreSvcOrgCreateOrgDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    httpOrgshdlOrgsHTTPHandlerCreate(
      authorization?: string,
      coreSvcOrgCreateOrgDTO?: CoreSvcOrgCreateOrgDTO,
      options?: any
    ): AxiosPromise<CoreSvcCreateOutput> {
      return localVarFp
        .httpOrgshdlOrgsHTTPHandlerCreate(authorization, coreSvcOrgCreateOrgDTO, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
  /**
   *
   * @summary admin HTTP Handler Run Org Event Migration 1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public httpAdminhdlAdminHTTPHandlerRunOrgEventMigration1(options?: AxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .httpAdminhdlAdminHTTPHandlerRunOrgEventMigration1(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Create
   * @param {string} [authorization]
   * @param {CoreSvcOrgCreateOrgDTO} [coreSvcOrgCreateOrgDTO]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public httpOrgshdlOrgsHTTPHandlerCreate(
    authorization?: string,
    coreSvcOrgCreateOrgDTO?: CoreSvcOrgCreateOrgDTO,
    options?: AxiosRequestConfig
  ) {
    return DefaultApiFp(this.configuration)
      .httpOrgshdlOrgsHTTPHandlerCreate(authorization, coreSvcOrgCreateOrgDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Returns the liveness status of the service
     * @summary Liveness Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilsHealthHandlerRegisterRoutes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns the liveness status of the service
     * @summary Liveness Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilsHealthHandlerRegisterRoutes2: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/health/live`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns the readiness status of the service
     * @summary Readiness Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilsHealthHandlerRegisterRoutes3: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/health/ready`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns detailed health status of all components
     * @summary Health Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilsHealthHandlerRegisterRoutes4: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/health/status`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration);
  return {
    /**
     * Returns the liveness status of the service
     * @summary Liveness Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilsHealthHandlerRegisterRoutes(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcUtilsHealthHandlerRegisterRoutes200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.utilsHealthHandlerRegisterRoutes(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns the liveness status of the service
     * @summary Liveness Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilsHealthHandlerRegisterRoutes2(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcUtilsHealthHandlerRegisterRoutes200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.utilsHealthHandlerRegisterRoutes2(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns the readiness status of the service
     * @summary Readiness Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilsHealthHandlerRegisterRoutes3(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.utilsHealthHandlerRegisterRoutes3(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns detailed health status of all components
     * @summary Health Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilsHealthHandlerRegisterRoutes4(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcHealthStatus>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.utilsHealthHandlerRegisterRoutes4(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = HealthApiFp(configuration);
  return {
    /**
     * Returns the liveness status of the service
     * @summary Liveness Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilsHealthHandlerRegisterRoutes(options?: any): AxiosPromise<CoreSvcUtilsHealthHandlerRegisterRoutes200Response> {
      return localVarFp.utilsHealthHandlerRegisterRoutes(options).then((request) => request(axios, basePath));
    },
    /**
     * Returns the liveness status of the service
     * @summary Liveness Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilsHealthHandlerRegisterRoutes2(options?: any): AxiosPromise<CoreSvcUtilsHealthHandlerRegisterRoutes200Response> {
      return localVarFp.utilsHealthHandlerRegisterRoutes2(options).then((request) => request(axios, basePath));
    },
    /**
     * Returns the readiness status of the service
     * @summary Readiness Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilsHealthHandlerRegisterRoutes3(options?: any): AxiosPromise<void> {
      return localVarFp.utilsHealthHandlerRegisterRoutes3(options).then((request) => request(axios, basePath));
    },
    /**
     * Returns detailed health status of all components
     * @summary Health Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilsHealthHandlerRegisterRoutes4(options?: any): AxiosPromise<CoreSvcHealthStatus> {
      return localVarFp.utilsHealthHandlerRegisterRoutes4(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
  /**
   * Returns the liveness status of the service
   * @summary Liveness Check
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HealthApi
   */
  public utilsHealthHandlerRegisterRoutes(options?: AxiosRequestConfig) {
    return HealthApiFp(this.configuration)
      .utilsHealthHandlerRegisterRoutes(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns the liveness status of the service
   * @summary Liveness Check
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HealthApi
   */
  public utilsHealthHandlerRegisterRoutes2(options?: AxiosRequestConfig) {
    return HealthApiFp(this.configuration)
      .utilsHealthHandlerRegisterRoutes2(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns the readiness status of the service
   * @summary Readiness Check
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HealthApi
   */
  public utilsHealthHandlerRegisterRoutes3(options?: AxiosRequestConfig) {
    return HealthApiFp(this.configuration)
      .utilsHealthHandlerRegisterRoutes3(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns detailed health status of all components
   * @summary Health Status
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HealthApi
   */
  public utilsHealthHandlerRegisterRoutes4(options?: AxiosRequestConfig) {
    return HealthApiFp(this.configuration)
      .utilsHealthHandlerRegisterRoutes4(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * OrgsApi - axios parameter creator
 * @export
 */
export const OrgsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary orgs HTTP Handler Bulk Update Orgs
     * @param {CoreSvcBulkUpdateOrgsInput} [coreSvcBulkUpdateOrgsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpdateOrgs: async (
      coreSvcBulkUpdateOrgsInput?: CoreSvcBulkUpdateOrgsInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/orgs/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcBulkUpdateOrgsInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Clear Scim Token
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clearScimToken: async (orgId: string, ifMatch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('clearScimToken', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/tokens/scim/`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (ifMatch != null) {
        localVarHeaderParameter['if-match'] = String(ifMatch);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary org Structure HTTP Handler Create Org Entity
     * @param {string} orgId
     * @param {CoreSvcDtosCreateOrgHierarchyEntityCreate} [coreSvcDtosCreateOrgHierarchyEntityCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOrgEntity: async (
      orgId: string,
      coreSvcDtosCreateOrgHierarchyEntityCreate?: CoreSvcDtosCreateOrgHierarchyEntityCreate,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createOrgEntity', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/structure/`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcDtosCreateOrgHierarchyEntityCreate,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Create Payment Org
     * @param {string} [authorization]
     * @param {CoreSvcOrgCreatePaymentOrgDTO} [coreSvcOrgCreatePaymentOrgDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPaymentOrg: async (
      authorization?: string,
      coreSvcOrgCreatePaymentOrgDTO?: CoreSvcOrgCreatePaymentOrgDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/orgs/enterprise-payments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcOrgCreatePaymentOrgDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Generate Scim Token
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateScimToken: async (
      orgId: string,
      ifMatch?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('generateScimToken', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/tokens/scim/`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (ifMatch != null) {
        localVarHeaderParameter['if-match'] = String(ifMatch);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Get Org
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrg: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getOrg', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary org Structure HTTP Handler Get Org Structure
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgStructure: async (
      orgId: string,
      pageToken?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getOrgStructure', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/structure/`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Get For User
     * @param {string} [pageToken]
     * @param {number} [pageSize]
     * @param {string} [xActAs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgsForUser: async (
      pageToken?: string,
      pageSize?: number,
      xActAs?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/orgs/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageToken !== undefined) {
        localVarQueryParameter['PageToken'] = pageToken;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
      }

      if (xActAs != null) {
        localVarHeaderParameter['X-Act-As'] = String(xActAs);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Update Org Enterprise Payment Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgEnterprisePaymentSettingsInput} [coreSvcUpdateOrgEnterprisePaymentSettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEnterprisePaymentSettings: async (
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgEnterprisePaymentSettingsInput?: CoreSvcUpdateOrgEnterprisePaymentSettingsInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateEnterprisePaymentSettings', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/settings/enterprise-payments`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (ifMatch != null) {
        localVarHeaderParameter['if-match'] = String(ifMatch);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcUpdateOrgEnterprisePaymentSettingsInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Update Feature Flags
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgFeatureFlagsInput} [coreSvcUpdateOrgFeatureFlagsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFeatureFlags: async (
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgFeatureFlagsInput?: CoreSvcUpdateOrgFeatureFlagsInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateFeatureFlags', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/settings/feature-flags`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (ifMatch != null) {
        localVarHeaderParameter['if-match'] = String(ifMatch);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcUpdateOrgFeatureFlagsInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Update Hard Close
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgHardCloseInput} [coreSvcUpdateOrgHardCloseInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHardClose: async (
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgHardCloseInput?: CoreSvcUpdateOrgHardCloseInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateHardClose', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/settings/hard-close`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (ifMatch != null) {
        localVarHeaderParameter['if-match'] = String(ifMatch);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcUpdateOrgHardCloseInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Update Org Accounting Inventory Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgAccountingInventorySettingsInput} [coreSvcUpdateOrgAccountingInventorySettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrgAccountingInventorySettings: async (
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgAccountingInventorySettingsInput?: CoreSvcUpdateOrgAccountingInventorySettingsInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateOrgAccountingInventorySettings', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/settings/accounting-inventory`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (ifMatch != null) {
        localVarHeaderParameter['if-match'] = String(ifMatch);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcUpdateOrgAccountingInventorySettingsInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Update Org Admin Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgAdminSettingsInput} [coreSvcUpdateOrgAdminSettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrgAdminSettings: async (
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgAdminSettingsInput?: CoreSvcUpdateOrgAdminSettingsInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateOrgAdminSettings', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/settings/admin`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (ifMatch != null) {
        localVarHeaderParameter['if-match'] = String(ifMatch);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcUpdateOrgAdminSettingsInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary org Structure HTTP Handler Update Org Entity
     * @param {string} orgId
     * @param {string} entityId
     * @param {CoreSvcStructurehdlUpdateInput} [coreSvcStructurehdlUpdateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrgEntity: async (
      orgId: string,
      entityId: string,
      coreSvcStructurehdlUpdateInput?: CoreSvcStructurehdlUpdateInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateOrgEntity', 'orgId', orgId);
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists('updateOrgEntity', 'entityId', entityId);
      const localVarPath = `/orgs/{orgId}/structure/{entityId}/`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'entityId'}}`, encodeURIComponent(String(entityId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcStructurehdlUpdateInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Update Org System Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgSystemSettingsInput} [coreSvcUpdateOrgSystemSettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrgSystemSettings: async (
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgSystemSettingsInput?: CoreSvcUpdateOrgSystemSettingsInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateOrgSystemSettings', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/settings/system`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (ifMatch != null) {
        localVarHeaderParameter['if-match'] = String(ifMatch);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcUpdateOrgSystemSettingsInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Update Wrapping Treatments
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgWrappingTreatmentsInput} [coreSvcUpdateOrgWrappingTreatmentsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrgWrappingTreatments: async (
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgWrappingTreatmentsInput?: CoreSvcUpdateOrgWrappingTreatmentsInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateOrgWrappingTreatments', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/settings/wrapping-treatments`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (ifMatch != null) {
        localVarHeaderParameter['if-match'] = String(ifMatch);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcUpdateOrgWrappingTreatmentsInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Update Wrapping Treatments
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgWrappingTreatmentsInput} [coreSvcUpdateOrgWrappingTreatmentsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrgWrappingTreatments2: async (
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgWrappingTreatmentsInput?: CoreSvcUpdateOrgWrappingTreatmentsInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateOrgWrappingTreatments2', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/settings/scim`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (ifMatch != null) {
        localVarHeaderParameter['if-match'] = String(ifMatch);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcUpdateOrgWrappingTreatmentsInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary orgs HTTP Handler Update Sso Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgSsoSettingsInput} [coreSvcUpdateOrgSsoSettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSsoSettings: async (
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgSsoSettingsInput?: CoreSvcUpdateOrgSsoSettingsInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateSsoSettings', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/settings/sso`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (ifMatch != null) {
        localVarHeaderParameter['if-match'] = String(ifMatch);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcUpdateOrgSsoSettingsInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OrgsApi - functional programming interface
 * @export
 */
export const OrgsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OrgsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary orgs HTTP Handler Bulk Update Orgs
     * @param {CoreSvcBulkUpdateOrgsInput} [coreSvcBulkUpdateOrgsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bulkUpdateOrgs(
      coreSvcBulkUpdateOrgsInput?: CoreSvcBulkUpdateOrgsInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcBulkUpdateOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateOrgs(coreSvcBulkUpdateOrgsInput, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Clear Scim Token
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clearScimToken(
      orgId: string,
      ifMatch?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clearScimToken(orgId, ifMatch, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary org Structure HTTP Handler Create Org Entity
     * @param {string} orgId
     * @param {CoreSvcDtosCreateOrgHierarchyEntityCreate} [coreSvcDtosCreateOrgHierarchyEntityCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createOrgEntity(
      orgId: string,
      coreSvcDtosCreateOrgHierarchyEntityCreate?: CoreSvcDtosCreateOrgHierarchyEntityCreate,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcStructurehdlGetUpdateOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createOrgEntity(
        orgId,
        coreSvcDtosCreateOrgHierarchyEntityCreate,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Create Payment Org
     * @param {string} [authorization]
     * @param {CoreSvcOrgCreatePaymentOrgDTO} [coreSvcOrgCreatePaymentOrgDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPaymentOrg(
      authorization?: string,
      coreSvcOrgCreatePaymentOrgDTO?: CoreSvcOrgCreatePaymentOrgDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcCreatePaymentOrgOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createPaymentOrg(
        authorization,
        coreSvcOrgCreatePaymentOrgDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Generate Scim Token
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generateScimToken(
      orgId: string,
      ifMatch?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcGenerateScimTokenOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.generateScimToken(orgId, ifMatch, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Get Org
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrg(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcOrg>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOrg(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary org Structure HTTP Handler Get Org Structure
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrgStructure(
      orgId: string,
      pageToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcStructurehdlGetListOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgStructure(orgId, pageToken, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Get For User
     * @param {string} [pageToken]
     * @param {number} [pageSize]
     * @param {string} [xActAs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrgsForUser(
      pageToken?: string,
      pageSize?: number,
      xActAs?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcGetShortListOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgsForUser(pageToken, pageSize, xActAs, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Update Org Enterprise Payment Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgEnterprisePaymentSettingsInput} [coreSvcUpdateOrgEnterprisePaymentSettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateEnterprisePaymentSettings(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgEnterprisePaymentSettingsInput?: CoreSvcUpdateOrgEnterprisePaymentSettingsInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcGetOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateEnterprisePaymentSettings(
        orgId,
        ifMatch,
        coreSvcUpdateOrgEnterprisePaymentSettingsInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Update Feature Flags
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgFeatureFlagsInput} [coreSvcUpdateOrgFeatureFlagsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateFeatureFlags(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgFeatureFlagsInput?: CoreSvcUpdateOrgFeatureFlagsInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcGetOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateFeatureFlags(
        orgId,
        ifMatch,
        coreSvcUpdateOrgFeatureFlagsInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Update Hard Close
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgHardCloseInput} [coreSvcUpdateOrgHardCloseInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateHardClose(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgHardCloseInput?: CoreSvcUpdateOrgHardCloseInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcGetOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateHardClose(
        orgId,
        ifMatch,
        coreSvcUpdateOrgHardCloseInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Update Org Accounting Inventory Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgAccountingInventorySettingsInput} [coreSvcUpdateOrgAccountingInventorySettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateOrgAccountingInventorySettings(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgAccountingInventorySettingsInput?: CoreSvcUpdateOrgAccountingInventorySettingsInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcGetOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrgAccountingInventorySettings(
        orgId,
        ifMatch,
        coreSvcUpdateOrgAccountingInventorySettingsInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Update Org Admin Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgAdminSettingsInput} [coreSvcUpdateOrgAdminSettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateOrgAdminSettings(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgAdminSettingsInput?: CoreSvcUpdateOrgAdminSettingsInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcGetOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrgAdminSettings(
        orgId,
        ifMatch,
        coreSvcUpdateOrgAdminSettingsInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary org Structure HTTP Handler Update Org Entity
     * @param {string} orgId
     * @param {string} entityId
     * @param {CoreSvcStructurehdlUpdateInput} [coreSvcStructurehdlUpdateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateOrgEntity(
      orgId: string,
      entityId: string,
      coreSvcStructurehdlUpdateInput?: CoreSvcStructurehdlUpdateInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcStructurehdlGetUpdateOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrgEntity(
        orgId,
        entityId,
        coreSvcStructurehdlUpdateInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Update Org System Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgSystemSettingsInput} [coreSvcUpdateOrgSystemSettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateOrgSystemSettings(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgSystemSettingsInput?: CoreSvcUpdateOrgSystemSettingsInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcGetOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrgSystemSettings(
        orgId,
        ifMatch,
        coreSvcUpdateOrgSystemSettingsInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Update Wrapping Treatments
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgWrappingTreatmentsInput} [coreSvcUpdateOrgWrappingTreatmentsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateOrgWrappingTreatments(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgWrappingTreatmentsInput?: CoreSvcUpdateOrgWrappingTreatmentsInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcGetOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrgWrappingTreatments(
        orgId,
        ifMatch,
        coreSvcUpdateOrgWrappingTreatmentsInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Update Wrapping Treatments
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgWrappingTreatmentsInput} [coreSvcUpdateOrgWrappingTreatmentsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateOrgWrappingTreatments2(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgWrappingTreatmentsInput?: CoreSvcUpdateOrgWrappingTreatmentsInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcGetOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrgWrappingTreatments2(
        orgId,
        ifMatch,
        coreSvcUpdateOrgWrappingTreatmentsInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary orgs HTTP Handler Update Sso Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgSsoSettingsInput} [coreSvcUpdateOrgSsoSettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSsoSettings(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgSsoSettingsInput?: CoreSvcUpdateOrgSsoSettingsInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcGetOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateSsoSettings(
        orgId,
        ifMatch,
        coreSvcUpdateOrgSsoSettingsInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * OrgsApi - factory interface
 * @export
 */
export const OrgsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = OrgsApiFp(configuration);
  return {
    /**
     *
     * @summary orgs HTTP Handler Bulk Update Orgs
     * @param {CoreSvcBulkUpdateOrgsInput} [coreSvcBulkUpdateOrgsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpdateOrgs(
      coreSvcBulkUpdateOrgsInput?: CoreSvcBulkUpdateOrgsInput,
      options?: any
    ): AxiosPromise<CoreSvcBulkUpdateOutput> {
      return localVarFp.bulkUpdateOrgs(coreSvcBulkUpdateOrgsInput, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Clear Scim Token
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clearScimToken(orgId: string, ifMatch?: string, options?: any): AxiosPromise<void> {
      return localVarFp.clearScimToken(orgId, ifMatch, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary org Structure HTTP Handler Create Org Entity
     * @param {string} orgId
     * @param {CoreSvcDtosCreateOrgHierarchyEntityCreate} [coreSvcDtosCreateOrgHierarchyEntityCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOrgEntity(
      orgId: string,
      coreSvcDtosCreateOrgHierarchyEntityCreate?: CoreSvcDtosCreateOrgHierarchyEntityCreate,
      options?: any
    ): AxiosPromise<CoreSvcStructurehdlGetUpdateOutput> {
      return localVarFp
        .createOrgEntity(orgId, coreSvcDtosCreateOrgHierarchyEntityCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Create Payment Org
     * @param {string} [authorization]
     * @param {CoreSvcOrgCreatePaymentOrgDTO} [coreSvcOrgCreatePaymentOrgDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPaymentOrg(
      authorization?: string,
      coreSvcOrgCreatePaymentOrgDTO?: CoreSvcOrgCreatePaymentOrgDTO,
      options?: any
    ): AxiosPromise<CoreSvcCreatePaymentOrgOutput> {
      return localVarFp
        .createPaymentOrg(authorization, coreSvcOrgCreatePaymentOrgDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Generate Scim Token
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateScimToken(orgId: string, ifMatch?: string, options?: any): AxiosPromise<CoreSvcGenerateScimTokenOutput> {
      return localVarFp.generateScimToken(orgId, ifMatch, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Get Org
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrg(orgId: string, options?: any): AxiosPromise<CoreSvcOrg> {
      return localVarFp.getOrg(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary org Structure HTTP Handler Get Org Structure
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgStructure(orgId: string, pageToken?: string, options?: any): AxiosPromise<CoreSvcStructurehdlGetListOutput> {
      return localVarFp.getOrgStructure(orgId, pageToken, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Get For User
     * @param {string} [pageToken]
     * @param {number} [pageSize]
     * @param {string} [xActAs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgsForUser(
      pageToken?: string,
      pageSize?: number,
      xActAs?: string,
      options?: any
    ): AxiosPromise<CoreSvcGetShortListOutput> {
      return localVarFp
        .getOrgsForUser(pageToken, pageSize, xActAs, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Update Org Enterprise Payment Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgEnterprisePaymentSettingsInput} [coreSvcUpdateOrgEnterprisePaymentSettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEnterprisePaymentSettings(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgEnterprisePaymentSettingsInput?: CoreSvcUpdateOrgEnterprisePaymentSettingsInput,
      options?: any
    ): AxiosPromise<CoreSvcGetOutput> {
      return localVarFp
        .updateEnterprisePaymentSettings(orgId, ifMatch, coreSvcUpdateOrgEnterprisePaymentSettingsInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Update Feature Flags
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgFeatureFlagsInput} [coreSvcUpdateOrgFeatureFlagsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFeatureFlags(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgFeatureFlagsInput?: CoreSvcUpdateOrgFeatureFlagsInput,
      options?: any
    ): AxiosPromise<CoreSvcGetOutput> {
      return localVarFp
        .updateFeatureFlags(orgId, ifMatch, coreSvcUpdateOrgFeatureFlagsInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Update Hard Close
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgHardCloseInput} [coreSvcUpdateOrgHardCloseInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHardClose(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgHardCloseInput?: CoreSvcUpdateOrgHardCloseInput,
      options?: any
    ): AxiosPromise<CoreSvcGetOutput> {
      return localVarFp
        .updateHardClose(orgId, ifMatch, coreSvcUpdateOrgHardCloseInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Update Org Accounting Inventory Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgAccountingInventorySettingsInput} [coreSvcUpdateOrgAccountingInventorySettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrgAccountingInventorySettings(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgAccountingInventorySettingsInput?: CoreSvcUpdateOrgAccountingInventorySettingsInput,
      options?: any
    ): AxiosPromise<CoreSvcGetOutput> {
      return localVarFp
        .updateOrgAccountingInventorySettings(orgId, ifMatch, coreSvcUpdateOrgAccountingInventorySettingsInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Update Org Admin Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgAdminSettingsInput} [coreSvcUpdateOrgAdminSettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrgAdminSettings(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgAdminSettingsInput?: CoreSvcUpdateOrgAdminSettingsInput,
      options?: any
    ): AxiosPromise<CoreSvcGetOutput> {
      return localVarFp
        .updateOrgAdminSettings(orgId, ifMatch, coreSvcUpdateOrgAdminSettingsInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary org Structure HTTP Handler Update Org Entity
     * @param {string} orgId
     * @param {string} entityId
     * @param {CoreSvcStructurehdlUpdateInput} [coreSvcStructurehdlUpdateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrgEntity(
      orgId: string,
      entityId: string,
      coreSvcStructurehdlUpdateInput?: CoreSvcStructurehdlUpdateInput,
      options?: any
    ): AxiosPromise<CoreSvcStructurehdlGetUpdateOutput> {
      return localVarFp
        .updateOrgEntity(orgId, entityId, coreSvcStructurehdlUpdateInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Update Org System Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgSystemSettingsInput} [coreSvcUpdateOrgSystemSettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrgSystemSettings(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgSystemSettingsInput?: CoreSvcUpdateOrgSystemSettingsInput,
      options?: any
    ): AxiosPromise<CoreSvcGetOutput> {
      return localVarFp
        .updateOrgSystemSettings(orgId, ifMatch, coreSvcUpdateOrgSystemSettingsInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Update Wrapping Treatments
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgWrappingTreatmentsInput} [coreSvcUpdateOrgWrappingTreatmentsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrgWrappingTreatments(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgWrappingTreatmentsInput?: CoreSvcUpdateOrgWrappingTreatmentsInput,
      options?: any
    ): AxiosPromise<CoreSvcGetOutput> {
      return localVarFp
        .updateOrgWrappingTreatments(orgId, ifMatch, coreSvcUpdateOrgWrappingTreatmentsInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Update Wrapping Treatments
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgWrappingTreatmentsInput} [coreSvcUpdateOrgWrappingTreatmentsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrgWrappingTreatments2(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgWrappingTreatmentsInput?: CoreSvcUpdateOrgWrappingTreatmentsInput,
      options?: any
    ): AxiosPromise<CoreSvcGetOutput> {
      return localVarFp
        .updateOrgWrappingTreatments2(orgId, ifMatch, coreSvcUpdateOrgWrappingTreatmentsInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary orgs HTTP Handler Update Sso Settings
     * @param {string} orgId
     * @param {string} [ifMatch]
     * @param {CoreSvcUpdateOrgSsoSettingsInput} [coreSvcUpdateOrgSsoSettingsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSsoSettings(
      orgId: string,
      ifMatch?: string,
      coreSvcUpdateOrgSsoSettingsInput?: CoreSvcUpdateOrgSsoSettingsInput,
      options?: any
    ): AxiosPromise<CoreSvcGetOutput> {
      return localVarFp
        .updateSsoSettings(orgId, ifMatch, coreSvcUpdateOrgSsoSettingsInput, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * OrgsApi - object-oriented interface
 * @export
 * @class OrgsApi
 * @extends {BaseAPI}
 */
export class OrgsApi extends BaseAPI {
  /**
   *
   * @summary orgs HTTP Handler Bulk Update Orgs
   * @param {CoreSvcBulkUpdateOrgsInput} [coreSvcBulkUpdateOrgsInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public bulkUpdateOrgs(coreSvcBulkUpdateOrgsInput?: CoreSvcBulkUpdateOrgsInput, options?: AxiosRequestConfig) {
    return OrgsApiFp(this.configuration)
      .bulkUpdateOrgs(coreSvcBulkUpdateOrgsInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Clear Scim Token
   * @param {string} orgId
   * @param {string} [ifMatch]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public clearScimToken(orgId: string, ifMatch?: string, options?: AxiosRequestConfig) {
    return OrgsApiFp(this.configuration)
      .clearScimToken(orgId, ifMatch, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary org Structure HTTP Handler Create Org Entity
   * @param {string} orgId
   * @param {CoreSvcDtosCreateOrgHierarchyEntityCreate} [coreSvcDtosCreateOrgHierarchyEntityCreate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public createOrgEntity(
    orgId: string,
    coreSvcDtosCreateOrgHierarchyEntityCreate?: CoreSvcDtosCreateOrgHierarchyEntityCreate,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .createOrgEntity(orgId, coreSvcDtosCreateOrgHierarchyEntityCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Create Payment Org
   * @param {string} [authorization]
   * @param {CoreSvcOrgCreatePaymentOrgDTO} [coreSvcOrgCreatePaymentOrgDTO]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public createPaymentOrg(
    authorization?: string,
    coreSvcOrgCreatePaymentOrgDTO?: CoreSvcOrgCreatePaymentOrgDTO,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .createPaymentOrg(authorization, coreSvcOrgCreatePaymentOrgDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Generate Scim Token
   * @param {string} orgId
   * @param {string} [ifMatch]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public generateScimToken(orgId: string, ifMatch?: string, options?: AxiosRequestConfig) {
    return OrgsApiFp(this.configuration)
      .generateScimToken(orgId, ifMatch, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Get Org
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public getOrg(orgId: string, options?: AxiosRequestConfig) {
    return OrgsApiFp(this.configuration)
      .getOrg(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary org Structure HTTP Handler Get Org Structure
   * @param {string} orgId
   * @param {string} [pageToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public getOrgStructure(orgId: string, pageToken?: string, options?: AxiosRequestConfig) {
    return OrgsApiFp(this.configuration)
      .getOrgStructure(orgId, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Get For User
   * @param {string} [pageToken]
   * @param {number} [pageSize]
   * @param {string} [xActAs]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public getOrgsForUser(pageToken?: string, pageSize?: number, xActAs?: string, options?: AxiosRequestConfig) {
    return OrgsApiFp(this.configuration)
      .getOrgsForUser(pageToken, pageSize, xActAs, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Update Org Enterprise Payment Settings
   * @param {string} orgId
   * @param {string} [ifMatch]
   * @param {CoreSvcUpdateOrgEnterprisePaymentSettingsInput} [coreSvcUpdateOrgEnterprisePaymentSettingsInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public updateEnterprisePaymentSettings(
    orgId: string,
    ifMatch?: string,
    coreSvcUpdateOrgEnterprisePaymentSettingsInput?: CoreSvcUpdateOrgEnterprisePaymentSettingsInput,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .updateEnterprisePaymentSettings(orgId, ifMatch, coreSvcUpdateOrgEnterprisePaymentSettingsInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Update Feature Flags
   * @param {string} orgId
   * @param {string} [ifMatch]
   * @param {CoreSvcUpdateOrgFeatureFlagsInput} [coreSvcUpdateOrgFeatureFlagsInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public updateFeatureFlags(
    orgId: string,
    ifMatch?: string,
    coreSvcUpdateOrgFeatureFlagsInput?: CoreSvcUpdateOrgFeatureFlagsInput,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .updateFeatureFlags(orgId, ifMatch, coreSvcUpdateOrgFeatureFlagsInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Update Hard Close
   * @param {string} orgId
   * @param {string} [ifMatch]
   * @param {CoreSvcUpdateOrgHardCloseInput} [coreSvcUpdateOrgHardCloseInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public updateHardClose(
    orgId: string,
    ifMatch?: string,
    coreSvcUpdateOrgHardCloseInput?: CoreSvcUpdateOrgHardCloseInput,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .updateHardClose(orgId, ifMatch, coreSvcUpdateOrgHardCloseInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Update Org Accounting Inventory Settings
   * @param {string} orgId
   * @param {string} [ifMatch]
   * @param {CoreSvcUpdateOrgAccountingInventorySettingsInput} [coreSvcUpdateOrgAccountingInventorySettingsInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public updateOrgAccountingInventorySettings(
    orgId: string,
    ifMatch?: string,
    coreSvcUpdateOrgAccountingInventorySettingsInput?: CoreSvcUpdateOrgAccountingInventorySettingsInput,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .updateOrgAccountingInventorySettings(orgId, ifMatch, coreSvcUpdateOrgAccountingInventorySettingsInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Update Org Admin Settings
   * @param {string} orgId
   * @param {string} [ifMatch]
   * @param {CoreSvcUpdateOrgAdminSettingsInput} [coreSvcUpdateOrgAdminSettingsInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public updateOrgAdminSettings(
    orgId: string,
    ifMatch?: string,
    coreSvcUpdateOrgAdminSettingsInput?: CoreSvcUpdateOrgAdminSettingsInput,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .updateOrgAdminSettings(orgId, ifMatch, coreSvcUpdateOrgAdminSettingsInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary org Structure HTTP Handler Update Org Entity
   * @param {string} orgId
   * @param {string} entityId
   * @param {CoreSvcStructurehdlUpdateInput} [coreSvcStructurehdlUpdateInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public updateOrgEntity(
    orgId: string,
    entityId: string,
    coreSvcStructurehdlUpdateInput?: CoreSvcStructurehdlUpdateInput,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .updateOrgEntity(orgId, entityId, coreSvcStructurehdlUpdateInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Update Org System Settings
   * @param {string} orgId
   * @param {string} [ifMatch]
   * @param {CoreSvcUpdateOrgSystemSettingsInput} [coreSvcUpdateOrgSystemSettingsInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public updateOrgSystemSettings(
    orgId: string,
    ifMatch?: string,
    coreSvcUpdateOrgSystemSettingsInput?: CoreSvcUpdateOrgSystemSettingsInput,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .updateOrgSystemSettings(orgId, ifMatch, coreSvcUpdateOrgSystemSettingsInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Update Wrapping Treatments
   * @param {string} orgId
   * @param {string} [ifMatch]
   * @param {CoreSvcUpdateOrgWrappingTreatmentsInput} [coreSvcUpdateOrgWrappingTreatmentsInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public updateOrgWrappingTreatments(
    orgId: string,
    ifMatch?: string,
    coreSvcUpdateOrgWrappingTreatmentsInput?: CoreSvcUpdateOrgWrappingTreatmentsInput,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .updateOrgWrappingTreatments(orgId, ifMatch, coreSvcUpdateOrgWrappingTreatmentsInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Update Wrapping Treatments
   * @param {string} orgId
   * @param {string} [ifMatch]
   * @param {CoreSvcUpdateOrgWrappingTreatmentsInput} [coreSvcUpdateOrgWrappingTreatmentsInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public updateOrgWrappingTreatments2(
    orgId: string,
    ifMatch?: string,
    coreSvcUpdateOrgWrappingTreatmentsInput?: CoreSvcUpdateOrgWrappingTreatmentsInput,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .updateOrgWrappingTreatments2(orgId, ifMatch, coreSvcUpdateOrgWrappingTreatmentsInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary orgs HTTP Handler Update Sso Settings
   * @param {string} orgId
   * @param {string} [ifMatch]
   * @param {CoreSvcUpdateOrgSsoSettingsInput} [coreSvcUpdateOrgSsoSettingsInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public updateSsoSettings(
    orgId: string,
    ifMatch?: string,
    coreSvcUpdateOrgSsoSettingsInput?: CoreSvcUpdateOrgSsoSettingsInput,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .updateSsoSettings(orgId, ifMatch, coreSvcUpdateOrgSsoSettingsInput, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PrincipalsApi - axios parameter creator
 * @export
 */
export const PrincipalsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Associates a principal with an organization and optionally assigns a role
     * @summary Add Principal to Organization
     * @param {string} orgId
     * @param {string} principalId
     * @param {CoreSvcPrincipalshdlCreateInput} [coreSvcPrincipalshdlCreateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPrincipalToOrg: async (
      orgId: string,
      principalId: string,
      coreSvcPrincipalshdlCreateInput?: CoreSvcPrincipalshdlCreateInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('addPrincipalToOrg', 'orgId', orgId);
      // verify required parameter 'principalId' is not null or undefined
      assertParamExists('addPrincipalToOrg', 'principalId', principalId);
      const localVarPath = `/orgs/{orgId}/principals/{principalId}/`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'principalId'}}`, encodeURIComponent(String(principalId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcPrincipalshdlCreateInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Removes a principal\'s association with an organization
     * @summary Delete Principal from Organization
     * @param {string} orgId
     * @param {string} principalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePrincipalFromOrg: async (
      orgId: string,
      principalId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('deletePrincipalFromOrg', 'orgId', orgId);
      // verify required parameter 'principalId' is not null or undefined
      assertParamExists('deletePrincipalFromOrg', 'principalId', principalId);
      const localVarPath = `/orgs/{orgId}/principals/{principalId}/`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'principalId'}}`, encodeURIComponent(String(principalId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets a specific principal\'s details within an organization
     * @summary Get Organization Principal
     * @param {string} orgId
     * @param {string} principalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgPrincipal: async (
      orgId: string,
      principalId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getOrgPrincipal', 'orgId', orgId);
      // verify required parameter 'principalId' is not null or undefined
      assertParamExists('getOrgPrincipal', 'principalId', principalId);
      const localVarPath = `/orgs/{orgId}/principals/{principalId}/`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'principalId'}}`, encodeURIComponent(String(principalId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lists all principals associated with an organization (one row per principal-role combination)
     * @summary List Organization Principals
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgPrincipals: async (
      orgId: string,
      pageToken?: string,
      pageSize?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getOrgPrincipals', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/principals/`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lists all principals with their roles and identities aggregated (one row per principal with arrays)
     * @summary List Organization Principals (Aggregated)
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgPrincipalsAggregated: async (
      orgId: string,
      pageToken?: string,
      pageSize?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getOrgPrincipalsAggregated', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/principals/aggregated`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates a principal\'s details within an organization
     * @summary Update Organization Principal
     * @param {string} orgId
     * @param {string} principalId
     * @param {CoreSvcPrincipalshdlUpdateInput} [coreSvcPrincipalshdlUpdateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePrincipalInOrg: async (
      orgId: string,
      principalId: string,
      coreSvcPrincipalshdlUpdateInput?: CoreSvcPrincipalshdlUpdateInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updatePrincipalInOrg', 'orgId', orgId);
      // verify required parameter 'principalId' is not null or undefined
      assertParamExists('updatePrincipalInOrg', 'principalId', principalId);
      const localVarPath = `/orgs/{orgId}/principals/{principalId}/`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'principalId'}}`, encodeURIComponent(String(principalId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcPrincipalshdlUpdateInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PrincipalsApi - functional programming interface
 * @export
 */
export const PrincipalsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PrincipalsApiAxiosParamCreator(configuration);
  return {
    /**
     * Associates a principal with an organization and optionally assigns a role
     * @summary Add Principal to Organization
     * @param {string} orgId
     * @param {string} principalId
     * @param {CoreSvcPrincipalshdlCreateInput} [coreSvcPrincipalshdlCreateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addPrincipalToOrg(
      orgId: string,
      principalId: string,
      coreSvcPrincipalshdlCreateInput?: CoreSvcPrincipalshdlCreateInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcPrincipalshdlCreateOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addPrincipalToOrg(
        orgId,
        principalId,
        coreSvcPrincipalshdlCreateInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Removes a principal\'s association with an organization
     * @summary Delete Principal from Organization
     * @param {string} orgId
     * @param {string} principalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePrincipalFromOrg(
      orgId: string,
      principalId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deletePrincipalFromOrg(orgId, principalId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Gets a specific principal\'s details within an organization
     * @summary Get Organization Principal
     * @param {string} orgId
     * @param {string} principalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrgPrincipal(
      orgId: string,
      principalId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcPrincipalshdlGetOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgPrincipal(orgId, principalId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Lists all principals associated with an organization (one row per principal-role combination)
     * @summary List Organization Principals
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrgPrincipals(
      orgId: string,
      pageToken?: string,
      pageSize?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcPrincipalshdlListOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgPrincipals(orgId, pageToken, pageSize, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Lists all principals with their roles and identities aggregated (one row per principal with arrays)
     * @summary List Organization Principals (Aggregated)
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrgPrincipalsAggregated(
      orgId: string,
      pageToken?: string,
      pageSize?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcPrincipalshdlListAggregatedOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgPrincipalsAggregated(
        orgId,
        pageToken,
        pageSize,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Updates a principal\'s details within an organization
     * @summary Update Organization Principal
     * @param {string} orgId
     * @param {string} principalId
     * @param {CoreSvcPrincipalshdlUpdateInput} [coreSvcPrincipalshdlUpdateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePrincipalInOrg(
      orgId: string,
      principalId: string,
      coreSvcPrincipalshdlUpdateInput?: CoreSvcPrincipalshdlUpdateInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcPrincipalshdlUpdateOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrincipalInOrg(
        orgId,
        principalId,
        coreSvcPrincipalshdlUpdateInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * PrincipalsApi - factory interface
 * @export
 */
export const PrincipalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = PrincipalsApiFp(configuration);
  return {
    /**
     * Associates a principal with an organization and optionally assigns a role
     * @summary Add Principal to Organization
     * @param {string} orgId
     * @param {string} principalId
     * @param {CoreSvcPrincipalshdlCreateInput} [coreSvcPrincipalshdlCreateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPrincipalToOrg(
      orgId: string,
      principalId: string,
      coreSvcPrincipalshdlCreateInput?: CoreSvcPrincipalshdlCreateInput,
      options?: any
    ): AxiosPromise<CoreSvcPrincipalshdlCreateOutput> {
      return localVarFp
        .addPrincipalToOrg(orgId, principalId, coreSvcPrincipalshdlCreateInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Removes a principal\'s association with an organization
     * @summary Delete Principal from Organization
     * @param {string} orgId
     * @param {string} principalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePrincipalFromOrg(orgId: string, principalId: string, options?: any): AxiosPromise<void> {
      return localVarFp.deletePrincipalFromOrg(orgId, principalId, options).then((request) => request(axios, basePath));
    },
    /**
     * Gets a specific principal\'s details within an organization
     * @summary Get Organization Principal
     * @param {string} orgId
     * @param {string} principalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgPrincipal(orgId: string, principalId: string, options?: any): AxiosPromise<CoreSvcPrincipalshdlGetOutput> {
      return localVarFp.getOrgPrincipal(orgId, principalId, options).then((request) => request(axios, basePath));
    },
    /**
     * Lists all principals associated with an organization (one row per principal-role combination)
     * @summary List Organization Principals
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgPrincipals(
      orgId: string,
      pageToken?: string,
      pageSize?: number,
      options?: any
    ): AxiosPromise<CoreSvcPrincipalshdlListOutput> {
      return localVarFp
        .getOrgPrincipals(orgId, pageToken, pageSize, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lists all principals with their roles and identities aggregated (one row per principal with arrays)
     * @summary List Organization Principals (Aggregated)
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgPrincipalsAggregated(
      orgId: string,
      pageToken?: string,
      pageSize?: number,
      options?: any
    ): AxiosPromise<CoreSvcPrincipalshdlListAggregatedOutput> {
      return localVarFp
        .getOrgPrincipalsAggregated(orgId, pageToken, pageSize, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates a principal\'s details within an organization
     * @summary Update Organization Principal
     * @param {string} orgId
     * @param {string} principalId
     * @param {CoreSvcPrincipalshdlUpdateInput} [coreSvcPrincipalshdlUpdateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePrincipalInOrg(
      orgId: string,
      principalId: string,
      coreSvcPrincipalshdlUpdateInput?: CoreSvcPrincipalshdlUpdateInput,
      options?: any
    ): AxiosPromise<CoreSvcPrincipalshdlUpdateOutput> {
      return localVarFp
        .updatePrincipalInOrg(orgId, principalId, coreSvcPrincipalshdlUpdateInput, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PrincipalsApi - object-oriented interface
 * @export
 * @class PrincipalsApi
 * @extends {BaseAPI}
 */
export class PrincipalsApi extends BaseAPI {
  /**
   * Associates a principal with an organization and optionally assigns a role
   * @summary Add Principal to Organization
   * @param {string} orgId
   * @param {string} principalId
   * @param {CoreSvcPrincipalshdlCreateInput} [coreSvcPrincipalshdlCreateInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrincipalsApi
   */
  public addPrincipalToOrg(
    orgId: string,
    principalId: string,
    coreSvcPrincipalshdlCreateInput?: CoreSvcPrincipalshdlCreateInput,
    options?: AxiosRequestConfig
  ) {
    return PrincipalsApiFp(this.configuration)
      .addPrincipalToOrg(orgId, principalId, coreSvcPrincipalshdlCreateInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Removes a principal\'s association with an organization
   * @summary Delete Principal from Organization
   * @param {string} orgId
   * @param {string} principalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrincipalsApi
   */
  public deletePrincipalFromOrg(orgId: string, principalId: string, options?: AxiosRequestConfig) {
    return PrincipalsApiFp(this.configuration)
      .deletePrincipalFromOrg(orgId, principalId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Gets a specific principal\'s details within an organization
   * @summary Get Organization Principal
   * @param {string} orgId
   * @param {string} principalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrincipalsApi
   */
  public getOrgPrincipal(orgId: string, principalId: string, options?: AxiosRequestConfig) {
    return PrincipalsApiFp(this.configuration)
      .getOrgPrincipal(orgId, principalId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lists all principals associated with an organization (one row per principal-role combination)
   * @summary List Organization Principals
   * @param {string} orgId
   * @param {string} [pageToken]
   * @param {number} [pageSize]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrincipalsApi
   */
  public getOrgPrincipals(orgId: string, pageToken?: string, pageSize?: number, options?: AxiosRequestConfig) {
    return PrincipalsApiFp(this.configuration)
      .getOrgPrincipals(orgId, pageToken, pageSize, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lists all principals with their roles and identities aggregated (one row per principal with arrays)
   * @summary List Organization Principals (Aggregated)
   * @param {string} orgId
   * @param {string} [pageToken]
   * @param {number} [pageSize]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrincipalsApi
   */
  public getOrgPrincipalsAggregated(
    orgId: string,
    pageToken?: string,
    pageSize?: number,
    options?: AxiosRequestConfig
  ) {
    return PrincipalsApiFp(this.configuration)
      .getOrgPrincipalsAggregated(orgId, pageToken, pageSize, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Updates a principal\'s details within an organization
   * @summary Update Organization Principal
   * @param {string} orgId
   * @param {string} principalId
   * @param {CoreSvcPrincipalshdlUpdateInput} [coreSvcPrincipalshdlUpdateInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrincipalsApi
   */
  public updatePrincipalInOrg(
    orgId: string,
    principalId: string,
    coreSvcPrincipalshdlUpdateInput?: CoreSvcPrincipalshdlUpdateInput,
    options?: AxiosRequestConfig
  ) {
    return PrincipalsApiFp(this.configuration)
      .updatePrincipalInOrg(orgId, principalId, coreSvcPrincipalshdlUpdateInput, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary roles HTTP Handler Create Role
     * @param {string} orgId
     * @param {CoreSvcRolesRoleCreateInput} [coreSvcRolesRoleCreateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRole: async (
      orgId: string,
      coreSvcRolesRoleCreateInput?: CoreSvcRolesRoleCreateInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createRole', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/roles/`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcRolesRoleCreateInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary roles HTTP Handler Get For Org
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgRoles: async (orgId: string, pageToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getOrgRoles', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/roles/`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary roles HTTP Handler Get Role
     * @param {string} orgId
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRole: async (orgId: string, roleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getRole', 'orgId', orgId);
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('getRole', 'roleId', roleId);
      const localVarPath = `/orgs/{orgId}/roles/{roleId}/`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'roleId'}}`, encodeURIComponent(String(roleId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary roles HTTP Handler Update Role
     * @param {string} orgId
     * @param {string} roleId
     * @param {CoreSvcRolesRoleUpdateInput} [coreSvcRolesRoleUpdateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRole: async (
      orgId: string,
      roleId: string,
      coreSvcRolesRoleUpdateInput?: CoreSvcRolesRoleUpdateInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateRole', 'orgId', orgId);
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('updateRole', 'roleId', roleId);
      const localVarPath = `/orgs/{orgId}/roles/{roleId}/`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'roleId'}}`, encodeURIComponent(String(roleId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcRolesRoleUpdateInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary roles HTTP Handler Create Role
     * @param {string} orgId
     * @param {CoreSvcRolesRoleCreateInput} [coreSvcRolesRoleCreateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createRole(
      orgId: string,
      coreSvcRolesRoleCreateInput?: CoreSvcRolesRoleCreateInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcRoleshdlCreateRolesOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createRole(orgId, coreSvcRolesRoleCreateInput, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary roles HTTP Handler Get For Org
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrgRoles(
      orgId: string,
      pageToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcRoleshdlGetOrgRolesOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgRoles(orgId, pageToken, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary roles HTTP Handler Get Role
     * @param {string} orgId
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRole(
      orgId: string,
      roleId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcRoleshdlGetRoleOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRole(orgId, roleId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary roles HTTP Handler Update Role
     * @param {string} orgId
     * @param {string} roleId
     * @param {CoreSvcRolesRoleUpdateInput} [coreSvcRolesRoleUpdateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRole(
      orgId: string,
      roleId: string,
      coreSvcRolesRoleUpdateInput?: CoreSvcRolesRoleUpdateInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(
        orgId,
        roleId,
        coreSvcRolesRoleUpdateInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = RolesApiFp(configuration);
  return {
    /**
     *
     * @summary roles HTTP Handler Create Role
     * @param {string} orgId
     * @param {CoreSvcRolesRoleCreateInput} [coreSvcRolesRoleCreateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRole(
      orgId: string,
      coreSvcRolesRoleCreateInput?: CoreSvcRolesRoleCreateInput,
      options?: any
    ): AxiosPromise<CoreSvcRoleshdlCreateRolesOutput> {
      return localVarFp
        .createRole(orgId, coreSvcRolesRoleCreateInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary roles HTTP Handler Get For Org
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgRoles(orgId: string, pageToken?: string, options?: any): AxiosPromise<CoreSvcRoleshdlGetOrgRolesOutput> {
      return localVarFp.getOrgRoles(orgId, pageToken, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary roles HTTP Handler Get Role
     * @param {string} orgId
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRole(orgId: string, roleId: string, options?: any): AxiosPromise<CoreSvcRoleshdlGetRoleOutput> {
      return localVarFp.getRole(orgId, roleId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary roles HTTP Handler Update Role
     * @param {string} orgId
     * @param {string} roleId
     * @param {CoreSvcRolesRoleUpdateInput} [coreSvcRolesRoleUpdateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRole(
      orgId: string,
      roleId: string,
      coreSvcRolesRoleUpdateInput?: CoreSvcRolesRoleUpdateInput,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateRole(orgId, roleId, coreSvcRolesRoleUpdateInput, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
  /**
   *
   * @summary roles HTTP Handler Create Role
   * @param {string} orgId
   * @param {CoreSvcRolesRoleCreateInput} [coreSvcRolesRoleCreateInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolesApi
   */
  public createRole(
    orgId: string,
    coreSvcRolesRoleCreateInput?: CoreSvcRolesRoleCreateInput,
    options?: AxiosRequestConfig
  ) {
    return RolesApiFp(this.configuration)
      .createRole(orgId, coreSvcRolesRoleCreateInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary roles HTTP Handler Get For Org
   * @param {string} orgId
   * @param {string} [pageToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolesApi
   */
  public getOrgRoles(orgId: string, pageToken?: string, options?: AxiosRequestConfig) {
    return RolesApiFp(this.configuration)
      .getOrgRoles(orgId, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary roles HTTP Handler Get Role
   * @param {string} orgId
   * @param {string} roleId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolesApi
   */
  public getRole(orgId: string, roleId: string, options?: AxiosRequestConfig) {
    return RolesApiFp(this.configuration)
      .getRole(orgId, roleId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary roles HTTP Handler Update Role
   * @param {string} orgId
   * @param {string} roleId
   * @param {CoreSvcRolesRoleUpdateInput} [coreSvcRolesRoleUpdateInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolesApi
   */
  public updateRole(
    orgId: string,
    roleId: string,
    coreSvcRolesRoleUpdateInput?: CoreSvcRolesRoleUpdateInput,
    options?: AxiosRequestConfig
  ) {
    return RolesApiFp(this.configuration)
      .updateRole(orgId, roleId, coreSvcRolesRoleUpdateInput, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ScopesApi - axios parameter creator
 * @export
 */
export const ScopesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary scopes HTTP Handler Get Scopes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScopes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/scopes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ScopesApi - functional programming interface
 * @export
 */
export const ScopesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ScopesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary scopes HTTP Handler Get Scopes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getScopes(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcScopeshdlGetScopesOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getScopes(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ScopesApi - factory interface
 * @export
 */
export const ScopesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ScopesApiFp(configuration);
  return {
    /**
     *
     * @summary scopes HTTP Handler Get Scopes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScopes(options?: any): AxiosPromise<CoreSvcScopeshdlGetScopesOutput> {
      return localVarFp.getScopes(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * ScopesApi - object-oriented interface
 * @export
 * @class ScopesApi
 * @extends {BaseAPI}
 */
export class ScopesApi extends BaseAPI {
  /**
   *
   * @summary scopes HTTP Handler Get Scopes
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScopesApi
   */
  public getScopes(options?: AxiosRequestConfig) {
    return ScopesApiFp(this.configuration)
      .getScopes(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TokensApi - axios parameter creator
 * @export
 */
export const TokensApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Create a new token
     * @summary Create Token
     * @param {string} orgId
     * @param {CoreSvcTokenshdlCreateTokenInput} [coreSvcTokenshdlCreateTokenInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createToken: async (
      orgId: string,
      coreSvcTokenshdlCreateTokenInput?: CoreSvcTokenshdlCreateTokenInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createToken', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/tokens/`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcTokenshdlCreateTokenInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Delete a token
     * @summary Delete Token
     * @param {string} orgId
     * @param {string} tokenId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteToken: async (orgId: string, tokenId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('deleteToken', 'orgId', orgId);
      // verify required parameter 'tokenId' is not null or undefined
      assertParamExists('deleteToken', 'tokenId', tokenId);
      const localVarPath = `/orgs/{orgId}/tokens/{tokenId}/`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'tokenId'}}`, encodeURIComponent(String(tokenId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get a specific token by ID
     * @summary Get Token
     * @param {string} orgId
     * @param {string} tokenId
     * @param {string} [principalId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getToken: async (
      orgId: string,
      tokenId: string,
      principalId?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getToken', 'orgId', orgId);
      // verify required parameter 'tokenId' is not null or undefined
      assertParamExists('getToken', 'tokenId', tokenId);
      const localVarPath = `/orgs/{orgId}/tokens/{tokenId}/`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'tokenId'}}`, encodeURIComponent(String(tokenId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (principalId !== undefined) {
        localVarQueryParameter['principalId'] = principalId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get all tokens for an organization with optional filtering
     * @summary Get Tokens
     * @param {string} orgId
     * @param {string} [tokenId]
     * @param {string} [serviceId]
     * @param {string} [principalId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTokens: async (
      orgId: string,
      tokenId?: string,
      serviceId?: string,
      principalId?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTokens', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/tokens/`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (tokenId !== undefined) {
        localVarQueryParameter['tokenId'] = tokenId;
      }

      if (serviceId !== undefined) {
        localVarQueryParameter['serviceId'] = serviceId;
      }

      if (principalId !== undefined) {
        localVarQueryParameter['principalId'] = principalId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Update an existing token
     * @summary Update Token
     * @param {string} orgId
     * @param {string} tokenId
     * @param {CoreSvcTokenshdlUpdateTokenInput} [coreSvcTokenshdlUpdateTokenInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateToken: async (
      orgId: string,
      tokenId: string,
      coreSvcTokenshdlUpdateTokenInput?: CoreSvcTokenshdlUpdateTokenInput,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateToken', 'orgId', orgId);
      // verify required parameter 'tokenId' is not null or undefined
      assertParamExists('updateToken', 'tokenId', tokenId);
      const localVarPath = `/orgs/{orgId}/tokens/{tokenId}/`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'tokenId'}}`, encodeURIComponent(String(tokenId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        coreSvcTokenshdlUpdateTokenInput,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TokensApi - functional programming interface
 * @export
 */
export const TokensApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TokensApiAxiosParamCreator(configuration);
  return {
    /**
     * Create a new token
     * @summary Create Token
     * @param {string} orgId
     * @param {CoreSvcTokenshdlCreateTokenInput} [coreSvcTokenshdlCreateTokenInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createToken(
      orgId: string,
      coreSvcTokenshdlCreateTokenInput?: CoreSvcTokenshdlCreateTokenInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcTokenshdlCreateTokenOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createToken(
        orgId,
        coreSvcTokenshdlCreateTokenInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Delete a token
     * @summary Delete Token
     * @param {string} orgId
     * @param {string} tokenId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteToken(
      orgId: string,
      tokenId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteToken(orgId, tokenId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get a specific token by ID
     * @summary Get Token
     * @param {string} orgId
     * @param {string} tokenId
     * @param {string} [principalId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getToken(
      orgId: string,
      tokenId: string,
      principalId?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcTokenshdlTokenOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getToken(orgId, tokenId, principalId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get all tokens for an organization with optional filtering
     * @summary Get Tokens
     * @param {string} orgId
     * @param {string} [tokenId]
     * @param {string} [serviceId]
     * @param {string} [principalId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTokens(
      orgId: string,
      tokenId?: string,
      serviceId?: string,
      principalId?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcTokenshdlTokensOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTokens(
        orgId,
        tokenId,
        serviceId,
        principalId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Update an existing token
     * @summary Update Token
     * @param {string} orgId
     * @param {string} tokenId
     * @param {CoreSvcTokenshdlUpdateTokenInput} [coreSvcTokenshdlUpdateTokenInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateToken(
      orgId: string,
      tokenId: string,
      coreSvcTokenshdlUpdateTokenInput?: CoreSvcTokenshdlUpdateTokenInput,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSvcTokenshdlTokenOutput>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateToken(
        orgId,
        tokenId,
        coreSvcTokenshdlUpdateTokenInput,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * TokensApi - factory interface
 * @export
 */
export const TokensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = TokensApiFp(configuration);
  return {
    /**
     * Create a new token
     * @summary Create Token
     * @param {string} orgId
     * @param {CoreSvcTokenshdlCreateTokenInput} [coreSvcTokenshdlCreateTokenInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createToken(
      orgId: string,
      coreSvcTokenshdlCreateTokenInput?: CoreSvcTokenshdlCreateTokenInput,
      options?: any
    ): AxiosPromise<CoreSvcTokenshdlCreateTokenOutput> {
      return localVarFp
        .createToken(orgId, coreSvcTokenshdlCreateTokenInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Delete a token
     * @summary Delete Token
     * @param {string} orgId
     * @param {string} tokenId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteToken(orgId: string, tokenId: string, options?: any): AxiosPromise<void> {
      return localVarFp.deleteToken(orgId, tokenId, options).then((request) => request(axios, basePath));
    },
    /**
     * Get a specific token by ID
     * @summary Get Token
     * @param {string} orgId
     * @param {string} tokenId
     * @param {string} [principalId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getToken(
      orgId: string,
      tokenId: string,
      principalId?: string,
      options?: any
    ): AxiosPromise<CoreSvcTokenshdlTokenOutput> {
      return localVarFp.getToken(orgId, tokenId, principalId, options).then((request) => request(axios, basePath));
    },
    /**
     * Get all tokens for an organization with optional filtering
     * @summary Get Tokens
     * @param {string} orgId
     * @param {string} [tokenId]
     * @param {string} [serviceId]
     * @param {string} [principalId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTokens(
      orgId: string,
      tokenId?: string,
      serviceId?: string,
      principalId?: string,
      options?: any
    ): AxiosPromise<CoreSvcTokenshdlTokensOutput> {
      return localVarFp
        .getTokens(orgId, tokenId, serviceId, principalId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update an existing token
     * @summary Update Token
     * @param {string} orgId
     * @param {string} tokenId
     * @param {CoreSvcTokenshdlUpdateTokenInput} [coreSvcTokenshdlUpdateTokenInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateToken(
      orgId: string,
      tokenId: string,
      coreSvcTokenshdlUpdateTokenInput?: CoreSvcTokenshdlUpdateTokenInput,
      options?: any
    ): AxiosPromise<CoreSvcTokenshdlTokenOutput> {
      return localVarFp
        .updateToken(orgId, tokenId, coreSvcTokenshdlUpdateTokenInput, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TokensApi - object-oriented interface
 * @export
 * @class TokensApi
 * @extends {BaseAPI}
 */
export class TokensApi extends BaseAPI {
  /**
   * Create a new token
   * @summary Create Token
   * @param {string} orgId
   * @param {CoreSvcTokenshdlCreateTokenInput} [coreSvcTokenshdlCreateTokenInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TokensApi
   */
  public createToken(
    orgId: string,
    coreSvcTokenshdlCreateTokenInput?: CoreSvcTokenshdlCreateTokenInput,
    options?: AxiosRequestConfig
  ) {
    return TokensApiFp(this.configuration)
      .createToken(orgId, coreSvcTokenshdlCreateTokenInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Delete a token
   * @summary Delete Token
   * @param {string} orgId
   * @param {string} tokenId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TokensApi
   */
  public deleteToken(orgId: string, tokenId: string, options?: AxiosRequestConfig) {
    return TokensApiFp(this.configuration)
      .deleteToken(orgId, tokenId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get a specific token by ID
   * @summary Get Token
   * @param {string} orgId
   * @param {string} tokenId
   * @param {string} [principalId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TokensApi
   */
  public getToken(orgId: string, tokenId: string, principalId?: string, options?: AxiosRequestConfig) {
    return TokensApiFp(this.configuration)
      .getToken(orgId, tokenId, principalId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get all tokens for an organization with optional filtering
   * @summary Get Tokens
   * @param {string} orgId
   * @param {string} [tokenId]
   * @param {string} [serviceId]
   * @param {string} [principalId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TokensApi
   */
  public getTokens(
    orgId: string,
    tokenId?: string,
    serviceId?: string,
    principalId?: string,
    options?: AxiosRequestConfig
  ) {
    return TokensApiFp(this.configuration)
      .getTokens(orgId, tokenId, serviceId, principalId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Update an existing token
   * @summary Update Token
   * @param {string} orgId
   * @param {string} tokenId
   * @param {CoreSvcTokenshdlUpdateTokenInput} [coreSvcTokenshdlUpdateTokenInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TokensApi
   */
  public updateToken(
    orgId: string,
    tokenId: string,
    coreSvcTokenshdlUpdateTokenInput?: CoreSvcTokenshdlUpdateTokenInput,
    options?: AxiosRequestConfig
  ) {
    return TokensApiFp(this.configuration)
      .updateToken(orgId, tokenId, coreSvcTokenshdlUpdateTokenInput, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
